<template>
    <b-modal
            id="invite-user-modal"
            :title="title"
            v-model="showModal"
            centered no-close-on-backdrop
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel">
        <b-overlay :show="isLoading" rounded="sm">

            <h5>Enter the email address of a user to invite them to join your organization.</h5>

            <form ref="form" v-on:submit.prevent="noop">
                <b-form-group
                        label="Email Address"
                        label-for="email-input"
                        invalid-feedback="Requires a valid email address e.g name@email.com"
                        :state="emailState">
                    <b-form-input
                            id="email-input"
                            placeholder="Enter email address"
                            v-model="emailValue"
                            required>
                    </b-form-input>
                </b-form-group>


               <b-form-group>
                 <b-form-select v-model="selectedRole" :options="roleOptions"></b-form-select>
               </b-form-group>

              <b-form-group>
                <b-form-checkbox
                    id="notify-checkbox"
                    v-model="notifyValue"
                    name="notify-checkbox"
                    value="true"
                    unchecked-value="false"
                >
                  Send Email Notification To User
                </b-form-checkbox>
              </b-form-group>

              <b-alert v-if="selectedRole == 'admin'" show variant="warning">
                <p><font-awesome-icon icon="exclamation-triangle" class="mx-2" />The invited user</p>
                <ul>
                    <li>Can Access <strong>and Modify</strong> Organization details</li>
                    <li>Can Access, Modify, Create and Delete <strong>All</strong> Athlete Profiles</li>
                   <li>Can Access, Modify, Create and Delete <strong>All</strong> Sessions</li>
                </ul>
              </b-alert>
              <b-alert v-else-if="selectedRole == 'athlete'" show variant="warning">
                <p><font-awesome-icon icon="exclamation-triangle" class="mx-2" />The invited user</p>
                <ul>
                  <li>Can Access but <strong>Not Modify</strong> Organization details</li>
                  <li>Can Create Athlete Profiles</li>
                  <li>Can <strong>only</strong> Access, Modify and Delete Athlete Profiles that they create</li>
                  <li>Can <strong>only</strong> Access, Modify, Create and Delete Sessions from Athlete Profiles they have access to.</li>
                </ul>
              </b-alert>

            </form>
        </b-overlay>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="primary" @click="ok()">
               Send User Invite
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="cancel()">
                Cancel
            </b-button>
        </template>

        <b-modal id="error-modal" size="sm" title="Action failed" ok-only centered>
            <p class="m-2">There was a problem completing the action, Please try again.</p>
        </b-modal>

    </b-modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: "OrganizationInviteUserModal",
        data() {
            return {
                showModal: false,

                title: "Invite User",

                emailValue: null,
                notifyValue: true,

                selectedRole: null,
                roleOptions: [
                  { value: null, text: 'Please select an option' },
                  { value: 'admin', text: 'Administrator  (full access)' },
                  { value: 'athlete', text: 'Athlete  (restricted access)' },
                ],


                showValidation: false,
                isLoading: false,
            }
        },
      watch: {
          showModal(newValue) {
            if(newValue) this.resetModel();
          }
        },
        computed: {
            ...mapGetters({
                organizationId: 'organization/currentId',
            }),

            emailState: function () {
                if (this.emailValue &&
                    this.emailValue.length > 2 &&
                    this.emailValue.length < 200 &&
                    this.isValidEmailAddress(this.emailValue)) {
                    return true
                }
                return this.showValidation ? false : null
            },
            validatedValue: function() {

                if(this.emailState && this.selectedRole) {
                    let value = {
                        organizationId: this.organizationId,
                        emailAddress: this.emailValue,
                        notify: this.notifyValue,
                        admin: this.selectedRole == 'admin'
                    };

                    return value;
                }

                return null;
            },
        },
        methods: {
            ...mapActions({
                inviteUser: 'organizationUserAccount/inviteUser',
            }),
            resetModel() {
                this.showValidation = false;
                this.emailValue = null;
                this.selectedRole = null;
            },
            handleOk(bvModalEvt) {

                let self = this;

                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                let value = this.validatedValue;
                if (value != null) {

                    self.isLoading = true;
                    self.inviteUser(value)
                       .then(function(success) {
                           if(success) {
                               self.resetModel(null);
                               self.closeModal();
                           } else {
                               self.$bvModal.show('error-modal')
                           }

                           self.isLoading = false;
                       });

                } else {
                    this.showValidation = true;
                }
            },
            handleCancel(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                this.closeModal()
            },
            closeModal() {
                this.$nextTick(() => {
                    this.$bvModal.hide('invite-user-modal')
                })
            },
            isValidEmailAddress(emailAddress) {
                let emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/;
                return emailReg.test(emailAddress);
            }
        }
    }
</script>

<style scoped>

</style>